require('./index.scss')

import Accordion from 'react-bootstrap/Accordion'
import { useSelector } from 'react-redux'

import { Show, Toggle } from '@/components/Accordion'
import { translate } from '@/utils/translations'

import AppliedPromo from './AppliedPromo'
import Field from './Field'

const eventKey = 'promo-code'

const PromoCode = () => {
  const promoCode = useSelector(state => state.cart.promoCode.name)
  const hasAppliedPromoCode = useSelector(
    state => state.cart.promoCode.hasAppliedPromoCode
  )
  const defaultKey = promoCode ? eventKey : null
  const isExpanded = Boolean(defaultKey)

  return (
    <Accordion defaultActiveKey={defaultKey}>
      <Toggle
        as='button'
        className='accordion__toggle-button'
        defaultExpanded={isExpanded}
        eventKey={eventKey}
      >
        {translate('promo_code.labels.promo_code')}
      </Toggle>
      <Show eventKey={eventKey}>
        <Choose>
          <When condition={hasAppliedPromoCode}>
            <AppliedPromo />
          </When>
          <Otherwise>
            <Field />
          </Otherwise>
        </Choose>
      </Show>
    </Accordion>
  )
}

export default PromoCode
